import { Number, Tooltip, Text, Skeleton } from "components/common"
import styles from "./index.module.less"
import { convertToHMSString } from "utils"

const StatsHeading = ({
  title,
  value,
  type,
  percentage,
  showValue = true,
  content,
  valueType = "number",
  isFetching,
}) => {
  return isFetching ? (
    <Skeleton />
  ) : content ? (
    <Tooltip title={content} placement={"bottomLeft"}>
      <div className={type === "extra" ? styles.alt : ""}>
        <div className={styles.statsTitle}>{title}</div>
        {showValue && <Number className={styles.statsValue} value={value} />} {percentage && percentage}
      </div>
    </Tooltip>
  ) : (
    <div className={type === "extra" ? styles.alt : ""}>
      <div className={styles.statsTitle}>{title}</div>
      {showValue &&
        (valueType == "time" ? (
          <Text className={styles.statsValue}>{convertToHMSString(value)}</Text>
        ) : (
          <Number
            className={styles.statsValue}
            value={value}
            {...(valueType === "currency" ? { isCurrency: true } : {})}
          />
        ))}
      {percentage && percentage}
    </div>
  )
}

export default StatsHeading
